import useOnclickOutside from "react-cool-onclickoutside"
import { Photo } from "../../../components/media/Photo"

export const VenuesMapMarkerWhite = ({ venue }: any) => {
  // console.log("VenuesMapMarkerWhite", venue.media)
  return (
    <div style={{ color: "red" }}>
      <div className="relative">
        <svg
          width="60"
          height="70"
          viewBox="0 0 60 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            boxShadow: "0.15s ease, background-color 0.15s ease-in",
            transform: "translateX(-30px) translateY(-70px)",
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.958008 29.2523C0.958008 13.5361 14.0913 0.833328 29.9773 0.833328C45.9081 0.833328 59.0413 13.5361 59.0413 29.2523C59.0413 37.1719 56.1611 44.5244 51.4205 50.7562C46.1906 57.6303 39.7445 63.6196 32.4889 68.3208C30.8283 69.4073 29.3296 69.4893 27.507 68.3208C20.21 63.6196 13.764 57.6303 8.57888 50.7562C3.83478 44.5244 0.958008 37.1719 0.958008 29.2523ZM9.82507 29.9644C9.82507 41.1616 18.8665 49.9682 29.9525 49.9682C41.0459 49.9682 50.1743 41.1616 50.1743 29.9644C50.1743 18.8544 41.0459 9.61904 29.9525 9.61904C18.8665 9.61904 9.82507 18.8544 9.82507 29.9644Z"
            fill="white"
          />
        </svg>
        {venue.media && venue.media.length > 0 ? (
          <div
            style={{
              width: 46,
              height: 46,
              top: 7,
              left: 7,
              borderRadius: 46,
              overflow: "hidden",
              transform: "translateX(-30px) translateY(-70px)",
            }}
            className="absolute"
          >
            <Photo
              media={venue.media[0] ?? "/assets/venues/default.jpg"}
              imgWidth={46}
              alt="Kids"
              radius
            />
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  )
}
